import React, { useState } from 'react';
import LayoutProvider from '../../../../../../Contexts/LayoutProvider';
import LibModal from '../../../../../../features/LibModal/LibModal';
import UpdatePackageModal from '../../Modals/UpdatePackageModal';
import { useServiceDt } from '../../ServiceDetailsProvider';
import TableMobile from './TableMobile';
import TableWeb from './TableWeb';

const demoData = [
    {
        id: 1,
        applicationId: 20,
        role: 'customer',
        packageName: 'Basic Package',
        priority: 0,
        prices: [],
        status: '',
        demo: true
    }
];

function PackagesTable() {
    const [packageItem, setPackageItem] = useState(0);

    const { serviceInfo, openModal, handleSelectPackage, handleReload } = useServiceDt();

    const data = serviceInfo?.packages || demoData;
    const isServiceInactive = serviceInfo?.status === 'inactive';

    const handleEditClick = (ev, item) => {
        ev.preventDefault();
        ev.stopPropagation();
        setPackageItem(item);
    };

    return (
        <>
            <LayoutProvider>
                <TableWeb
                    layout="default"
                    data={data}
                    handleSelectPackage={handleSelectPackage}
                    isServiceInactive={isServiceInactive}
                    handleEditClick={handleEditClick}
                />
                <TableMobile
                    layout={['md', 'sm', 'xs', 'xxs']}
                    data={data}
                    openModal={openModal}
                    handleSelectPackage={handleSelectPackage}
                    isServiceInactive={isServiceInactive}
                    handleEditClick={handleEditClick}
                />
            </LayoutProvider>

            {packageItem?.id && (
                <LibModal title="Update Package" setOpen={setPackageItem}>
                    <UpdatePackageModal
                        closeModal={() => setPackageItem(0)}
                        handleReload={handleReload}
                        packageInfo={packageItem}
                        serviceInfo={serviceInfo}
                    />
                </LibModal>
            )}
        </>
    );
}

export default PackagesTable;
